import { RcFile } from "antd/lib/upload/interface";
import { Upload } from "@formily/antd";
import { Button, Modal } from "antd";
import { UploadFile } from "antd/lib/upload/interface";
import { DownloadKind, downloadStaticFile } from "../unit/download";
const ExcelUpload = (props: any) => {
  return (
    <div>
      <Button
        type="link"
        onClick={() => {
          downloadStaticFile(DownloadKind.EptTemplate);
        }}
      >
        模板下载
      </Button>
      <Upload
        {...props}
        accept=".png,.jpg,.jpeg,.bmp,.rar,.zip,.7z,.tar,.gz,.xls,.xlsx,.xlsm"
        multiple={false}
        maxCount={1}
        beforeUpload={(file: any): boolean => {
          if (file.size > 30 * 1024 * 1024) {
            Modal.error({
              title: "文件大小超出限制",
              content: "请上传小于30M的文件",
            });
          }
          return false;
        }}
      >
        <Button>上传</Button>{" "}
        <span>
          只支持 .png,.jpg,.jpeg,.bmp,.rar,.zip,.7z,.tar,.gz,.xls,.xlsx,.xlsm
          格式
        </span>
      </Upload>
    </div>
  );
};
const ImageUpload = (props: any) => {
  return (
    <Upload
      {...props}
      accept=".png,.jpeg,.jpg,.bmp,.rar,.zip,.7z,.tar,.gz"
      multiple={false}
      maxCount={1}
      beforeUpload={(file: RcFile): boolean => {
        if (file.size > 30 * 1024 * 1024) {
          Modal.error({
            title: "文件大小超出限制",
            content: "请上传小于30M的文件",
          });
        } else {
          //ok
          console.log(file);
        }
        return false;
      }}
    >
      <Button>上传</Button>{" "}
      <span>只支持 .png,.jpg,.jpeg,.bmp,.rar,.zip,.7z,.tar,.gz 格式</span>
    </Upload>
  );
};
export { ExcelUpload, ImageUpload };
